import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import apiService from 'services/api';

function Version({ classes }: any) {
  const [version, setVersion] = useState('');

  useEffect(() => {
    const sub = apiService.get('/version').subscribe(setVersion);
    return () => sub.unsubscribe();
  }, []);

  return (
    <div className={classes.versionWrapper}>
      <Typography variant="caption" className={classes.versionNo}>
        {version}
      </Typography>
    </div>
  );
}

export default withStyles((theme) => ({
  versionWrapper: {
    display: 'flex',
    alignItems: 'end',
    justifyContent: 'center',
    marginBottom: theme.spacing(1),
  },
  versionNo: {
    color: theme.palette.grey[600],
  }
}))(Version);